const { useState } = wp.element;

// Components
import Icon from './icon';

/**
 * A button that will centre map to users location
 *
 * @param {Function} panTo A function that moves the map
 * @return {JSX.Element} The button
 */
const Locate = ( { panTo, setCurrentLocation } ) => {
	const { retailerTranslations } = window.QalaB2bWholesale.translations;
	const [ isLocating, setIsLocating ] = useState( false );
	return (
		<button
			className="btn btn--red"
			onClick={ () => {
				setIsLocating( true );
				window.navigator.geolocation.getCurrentPosition(
					position => {
						panTo( {
							lat: position.coords.latitude,
							lng: position.coords.longitude,
						} );
						setCurrentLocation( {
							lat: position.coords.latitude,
							lng: position.coords.longitude,
						} );
						setIsLocating( false );
					},
					() => {
						console.error( 'Maps encountered an error when locating user' ); // eslint-disable-line no-console
					}
				);
			} }
		>
			{ isLocating ? <Icon name="loading" /> : <Icon name="navigation" /> }
			{ retailerTranslations.findNearestRetailer }
		</button>
	);
};

export default Locate;
